// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ArrowNarrowLeftIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ArrowNarrowLeft/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.707 14.707a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L5.414 9H17a1 1 0 0 1 0 2H5.414l2.293 2.293a1 1 0 0 1 0 1.414Z",
  clipRule: "evenodd"
}));
export default ArrowNarrowLeftIcon;